<template>
	<div class="container__registers">
		<ContentHeader>
			<SubHeader :title="title" />
		</ContentHeader>
		<ContentBody>
			<Card>
				<router-view />
			</Card>
		</ContentBody>
	</div>
</template>

<script>
import 'vuetify/dist/vuetify.min.css'

import Card from '../../components/Card/Card'
import ContentBody from '../../components/ContentBody/ContentBody'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import SubHeader from '../../components/SubHeader/SubHeader'

export default {
	components: { Card, ContentBody, ContentHeader, SubHeader },
	data: () => {
		return {
			activeRoute: '',
		}
	},
	computed: {
		title() {
			return `${this.$t('prognosis')} / ${this.label}`
		},
		label() {
			return this.labelAndLinkName.filter((f) => f.linkName === this.activeRoute)[0].label
		},
		labelAndLinkName() {
			return [
				{ label: this.$t('siteClassification'), linkName: 'classificacao' },
				{ label: this.$t('prognosis'), linkName: 'prognose' },
				{ label: this.$t('linkPrognosis'), linkName: 'vincular' },
				{ label: this.$t('historicalData'), linkName: 'baseHistorica' },
			]
		},
	},
	watch: {
		$route(to) {
			this.activeRoute = to.name
		},
	},
	created() {
		this.activeRoute = this.$route.name
	},
}
</script>
